import moment from "moment"
import React from "react"
import { Link } from "react-router-dom"
import { Badge } from "reactstrap"

const SrNo = cell => {
  return (
    <Link to="#" className="text-body fw-bold">
      {cell.value ? cell.value : ""}
    </Link>
  )
}
const VehicleMake = cell => {
  return cell.value ? cell.value : ""
}

const VehicleModel = cell => {
    return cell.value ? cell.value : ""
  }

const Notes = cell => {
  return cell.value ? cell.value : ""
}

const CreatedBy = cell =>{
  return cell.value ? cell.value : ""
}

const CreatedAt = cell => {
  return cell.value ? moment(cell.value).format("DD/MM/YYYY") : ""
}

const Status = cell => {
  return <div className="text-center">{cell.value ? 
  cell.value === "Done" ? <Badge color="success" className="fs-5">&nbsp; &nbsp; {cell.value} &nbsp; &nbsp;</Badge>:
  cell.value === "Pending" ? <Badge color="warning" className="fs-5">{cell.value}&nbsp;</Badge> :
  <Badge color="danger" className="fs-5">{cell.value}</Badge> :""}</div>
}


export { SrNo, VehicleMake, VehicleModel, Notes, Status, CreatedBy, CreatedAt }

